module.exports = __webpack_public_path__ + "img/PriorityToday.8b202fd4.svg";